import { render, staticRenderFns } from "./deduvtionAudition.vue?vue&type=template&id=a21b8db6&scoped=true"
import script from "./deduvtionAudition.vue?vue&type=script&lang=js"
export * from "./deduvtionAudition.vue?vue&type=script&lang=js"
import style0 from "./deduvtionAudition.vue?vue&type=style&index=0&id=a21b8db6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21b8db6",
  null
  
)

export default component.exports